<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" :model="form" class="demo-form-inline " label-width="125px">
        <el-form-item label="业务系统" prop="sysId">
          <el-select v-model="form.sysId"  clearable filterable placeholder="请选择业务系统">
            <el-option :label="item.systemName" :value="item.systemId" v-for="(item, $index) in sysData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称" prop="virtualSellerCode">
          <el-select v-model="form.virtualSellerCode"  clearable filterable placeholder="请选择商户名称">
            <el-option :label="item.virtualSellerName" :value="item.virtualSellerCode" v-for="(item, $index) in form.serviceData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付渠道" prop="payChannelCode">
          <el-select v-model="form.payChannelCode" clearable filterable placeholder="请选择支付渠道">
            <el-option :label="item.payChannelName" :value="item.payChannelCode" v-for="(item, $index) in form.payChannelData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日账单时间" prop="date">
          <el-date-picker
            v-model="form.date"
            :editable = "editable"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="业务订单号" prop="serviceTradeNo">
          <el-input style="width: 217px;" placeholder="请输入业务订单号" clearable v-model="form.serviceTradeNo"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="支付订单号" prop="outTradeNo">
          <el-input style="width: 217px;" placeholder="请输入支付订单号" clearable v-model="form.outTradeNo"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否生成核算单" prop="accountState">
          <el-select v-model="form.accountState" clearable filterable placeholder="请选择是否生成核算单">
            <el-option label="已生成" value="1" ></el-option>
            <el-option label="未生成" value="0" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否生成结算单" prop="settleState">
          <el-select v-model="form.settleState" clearable filterable placeholder="请选择是否生成结算单">
            <el-option label="已生成" value="1" ></el-option>
            <el-option label="未生成" value="0" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
          <!-- <el-button type="primary" size="small" @click="downBill">账单下载</el-button> -->
          <el-button type="primary" size="small" @click="createAccount">生成核算单</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="系统名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="商户名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.virtualSellerName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账单日期"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.billDate }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="业务订单号"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.serviceTradeNo }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="支付订单号"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.outTradeNo }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="支付渠道"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.payChannelName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="支付金额(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.payAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账单金额(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.checkAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手续费(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.brokerage }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账单状态"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.checkResult === '0' ? '正常' : '异常' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否生成核算单"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.checkSheetFlag === '1'?'已生成':'未生成' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否生成结算单"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.settlementFlag === '1'?'已生成':'未生成' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.custome-height {
  height: 700px;
  overflow-y: scroll;
}
.img {
  width: 100px;
  height: 100px;
}
.ml {
  margin-left: 10px;
}
.mt {
  margin-top: 10px;
}
.center {
  text-align: right;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.wid {
  flex: 1;
}
</style>
<script>
export default {
  name: 'kinderBill',
  data () {
    return {
      form: {
        sysId: '', // 系统id
        serviceData: [], // 商户名称
        payChannelData: [], // 支付渠道
        payChannelCode: '', // 支付渠道id
        virtualSellerCode: '', // 商户名称id
        serviceTradeNo: '', // 业务订单号
        outTradeNo: '', // 支付订单号
        date: '',
        accountState: '',
        settleState: ''
      },
      tooltip: true,
      editable: false,
      supData: [],
      tableData: [],
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.query()
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    downBill () { // 账单下载
      let op = {}
      op.startTime = this.form.date ? this.form.date[0] : ''
      op.endTime = this.form.date ? this.form.date[1] : ''
      op.custId = this.form.custId
      op.sysId = this.form.sysId
      op.checkSheetFlag = this.form.accountState
      op.settlementFlag = this.form.settleState
      if (!op.sysId) {
        this.$message.error('请选择系统名称')
        return
      }
      if (!op.custId) {
        this.$message.error('请选择客户名称')
        return
      }
      if (!op.startTime) {
        this.$message.error('请选择日账单时间')
        return
      }
      if (!op.endTime) {
        this.$message.error('请选择日账单时间')
        return
      }
      let url = this.$API.billmanagement.downlodeCustBillInfo
      if (op.startTime && op.endTime && op.sysId && op.custId) {
        let params = { // 参数
          custId: this.form.custId,
          sysId: this.form.sysId,
          checkSheetFlag: op.checkSheetFlag,
          settlementFlag: op.settlementFlag,
          startTime: op.startTime,
          endTime: op.endTime,
          mtk: localStorage.getItem('usermtk')
        }
        let form = document.createElement('form')
        form.id = 'form'
        form.name = 'form'
        document.body.appendChild(form)
        for (let obj in params) {
          if (params.hasOwnProperty(obj)) {
            var input = document.createElement('input')
            input.tpye = 'hidden'
            input.name = obj
            input.value = params[obj]
            form.appendChild(input)
          }
        }
        form.method = 'POST' // 请求方式
        form.action = url
        form.submit()
        document.body.removeChild(form)
      }
    },
    createAccount () { // 生成核算单
      let op = {}
      op.startTime = this.form.date ? this.form.date[0] : ''
      op.endTime = this.form.date ? this.form.date[1] : ''
      op.virtualSellerCode = this.form.virtualSellerCode
      op.payChannelCode = this.form.payChannelCode
      op.sysId = this.form.sysId
      if (!op.sysId) {
        this.$message.error('请选择系统名称')
        return
      }
      if (!op.virtualSellerCode) {
        this.$message.error('请选择商户名称')
        return
      }
      if (!op.payChannelCode) {
        this.$message.error('请选择支付渠道')
        return
      }
      if (!op.startTime) {
        this.$message.error('请选择日账单时间')
        return
      }
      if (!op.endTime) {
        this.$message.error('请选择日账单时间')
        return
      }
      if (op.startTime && op.endTime && op.sysId && op.virtualSellerCode && op.payChannelCode) {
        let _this = this
        this.$axios({
          url: _this.$API.billmanagement.addPaymentBillCheck,
          method: 'post',
          data: op
        }).then((response) => {
          _this.query()
          _this.$message.success('生成核算单成功！')
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
      this.form.sysId = ''
      this.form.payChannelCode = ''
      this.form.virtualSellerCode = ''
      this.form.serviceTradeNo = ''
      this.form.outTradeNo = ''
      this.form.date = ''
      this.form.accountState = ''
      this.form.settleState = ''
    },
    initData () {
      this.$store.dispatch('getSystem') // 请求业务系统
      let _this = this
      this.$axios({ // 请求商户名称
        url: _this.$API.pay.queryVirtualSellerList,
        method: 'get'
      }).then((response) => {
        if (!response.data.resData) return
        _this.form.serviceData = response.data.resData.sellerList
      }).catch((err) => {
        console.log(err)
      })
      this.$axios({ // 请求支付渠道
        url: _this.$API.pay.queryPayChannelList,
        method: 'get'
      }).then((response) => {
        if (!response.data.resData) return
        _this.form.payChannelData = response.data.resData.channelList
      }).catch((err) => {
        console.log(err)
      })
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      let id = this.form.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.virtualSellerCode = this.form.virtualSellerCode
      op.sysIds = sysIds
      op.checkSheetFlag = this.form.accountState
      op.settlementFlag = this.form.settleState
      op.payChannelCode = this.form.payChannelCode
      op.serviceTradeNo = this.form.serviceTradeNo
      op.outTradeNo = this.form.outTradeNo
      op.startTime = this.form.date ? this.form.date[0] + ' 00:00:00' : ''
      op.endTime = this.form.date ? this.form.date[1] + ' 23:59:59' : ''
      this.$axios({
        url: _this.$API.billmanagement.queryPaymentBillCheckDetailByPage,
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/billManagement/kinderBill.vue